import { forwardRef } from 'react'
import TextField from '@mui/material/TextField'

const MapitPhoneInputComponent = (props, ref) => {

  return (
    <TextField
      {...props}
      inputRef={ref}
      fullWidth
      size='small'
      variant='outlined'
      name='phone'
    />
  )
}
export default forwardRef(MapitPhoneInputComponent)